export const SEGMENT_IFACE_EDITOR_SETTINGS_KEY = 'SEGMENT_IFACE_EDITOR_SETTINGS';

/**
 * @typedef {{
 *  default_polygon_size: [number, number] | [null, null],
 *  disable_image_smoothing: boolean,
 *  polygon_copy_to_mouse_pos: boolean,
 * }} SegmentationInterfaceSettings
 * */

/** @type SegmentationInterfaceSettings */
const defaultSettings = {
  default_polygon_size: [null, null],
  disable_image_smoothing: false,
  polygon_copy_to_mouse_pos: false,
};

export default {
  /**
   * @returns {SegmentationInterfaceSettings}
   */
  getDefaultInterfaceSettings() {
    return defaultSettings;
  },
  /**
   * @returns {SegmentationInterfaceSettings}
   */
  getInterfaceSettings() {
    const settings = JSON.parse(window.localStorage.getItem(SEGMENT_IFACE_EDITOR_SETTINGS_KEY) || '{}');
    return {
      default_polygon_size: settings.default_polygon_size || defaultSettings.default_polygon_size,
      disable_image_smoothing: settings.disable_image_smoothing || defaultSettings.disable_image_smoothing,
      polygon_copy_to_mouse_pos: settings.polygon_copy_to_mouse_pos || defaultSettings.polygon_copy_to_mouse_pos,
    };
  },
  /**
   * @param {SegmentationInterfaceSettings} settings
   */
  setInterfaceSettings(settings) {
    window.localStorage.setItem(SEGMENT_IFACE_EDITOR_SETTINGS_KEY, JSON.stringify({
      default_polygon_size: settings.default_polygon_size || [null, null],
      disable_image_smoothing: settings.disable_image_smoothing || false,
      polygon_copy_to_mouse_pos: settings.polygon_copy_to_mouse_pos || false,
    }));
  },
};
